module.exports = __webpack_public_path__ + "media/images/shared/bgi-js-model-5e135c7728fcd6eb535c02c6ac80bbc6.jpg";